@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(-1_454_974_777)
internal val Res.string.discover_groups_group_name_label: StringResource by lazy {
      StringResource("string:discover_groups_group_name_label", "discover_groups_group_name_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11500, 80),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8640, 56),
      ))
    }

@delegate:ResourceContentHash(555_048_272)
internal val Res.string.discover_groups_group_name_placeholder: StringResource by lazy {
      StringResource("string:discover_groups_group_name_placeholder", "discover_groups_group_name_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11581, 94),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8697, 70),
      ))
    }

@delegate:ResourceContentHash(2_132_732_680)
internal val Res.string.discover_groups_group_title: StringResource by lazy {
      StringResource("string:discover_groups_group_title", "discover_groups_group_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11676, 51),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8768, 43),
      ))
    }

@delegate:ResourceContentHash(1_950_003_813)
internal val Res.string.discover_groups_group_unavailable_body: StringResource by lazy {
      StringResource("string:discover_groups_group_unavailable_body", "discover_groups_group_unavailable_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11728, 126),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8812, 86),
      ))
    }

@delegate:ResourceContentHash(-688_152_882)
internal val Res.string.discover_groups_group_unavailable_title: StringResource by lazy {
      StringResource("string:discover_groups_group_unavailable_title", "discover_groups_group_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11855, 95),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8899, 71),
      ))
    }

@delegate:ResourceContentHash(-548_211_359)
internal val Res.string.discover_groups_group_username_label: StringResource by lazy {
      StringResource("string:discover_groups_group_username_label", "discover_groups_group_username_label", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 11951, 80),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 8971, 64),
      ))
    }

@delegate:ResourceContentHash(-1_313_675_061)
internal val Res.string.discover_groups_group_username_placeholder: StringResource by lazy {
      StringResource("string:discover_groups_group_username_placeholder", "discover_groups_group_username_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9036, 62),
      ))
    }

@delegate:ResourceContentHash(754_182_412)
internal val Res.string.discover_groups_invite_admins_only: StringResource by lazy {
      StringResource("string:discover_groups_invite_admins_only", "discover_groups_invite_admins_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12032, 214),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9099, 126),
      ))
    }

@delegate:ResourceContentHash(-15_761_323)
internal val Res.string.discover_groups_invite_create: StringResource by lazy {
      StringResource("string:discover_groups_invite_create", "discover_groups_invite_create", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12527, 105),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9430, 61),
      ))
    }

@delegate:ResourceContentHash(-44_930_235)
internal val Res.string.discover_groups_invite_create_confirm: StringResource by lazy {
      StringResource("string:discover_groups_invite_create_confirm", "discover_groups_invite_create_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12247, 81),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9226, 61),
      ))
    }

@delegate:ResourceContentHash(2_025_899_151)
internal val Res.string.discover_groups_invite_create_title: StringResource by lazy {
      StringResource("string:discover_groups_invite_create_title", "discover_groups_invite_create_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12329, 127),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9288, 79),
      ))
    }

@delegate:ResourceContentHash(1_132_050_744)
internal val Res.string.discover_groups_invite_created_on: StringResource by lazy {
      StringResource("string:discover_groups_invite_created_on", "discover_groups_invite_created_on", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12457, 69),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9368, 61),
      ))
    }

@delegate:ResourceContentHash(1_086_249_082)
internal val Res.string.discover_groups_invite_history_note: StringResource by lazy {
      StringResource("string:discover_groups_invite_history_note", "discover_groups_invite_history_note", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 12633, 371),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9492, 171),
      ))
    }

@delegate:ResourceContentHash(1_906_829_684)
internal val Res.string.discover_groups_invite_replace: StringResource by lazy {
      StringResource("string:discover_groups_invite_replace", "discover_groups_invite_replace", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13122, 78),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9745, 54),
      ))
    }

@delegate:ResourceContentHash(-190_450_487)
internal val Res.string.discover_groups_invite_replace_title: StringResource by lazy {
      StringResource("string:discover_groups_invite_replace_title", "discover_groups_invite_replace_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13005, 116),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9664, 80),
      ))
    }

@delegate:ResourceContentHash(2_086_872_191)
internal val Res.string.discover_groups_invite_show: StringResource by lazy {
      StringResource("string:discover_groups_invite_show", "discover_groups_invite_show", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13201, 107),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9800, 59),
      ))
    }

@delegate:ResourceContentHash(255_953_618)
internal val Res.string.discover_groups_invite_title: StringResource by lazy {
      StringResource("string:discover_groups_invite_title", "discover_groups_invite_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13309, 68),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9860, 44),
      ))
    }

@delegate:ResourceContentHash(-984_997_535)
internal val Res.string.discover_groups_invite_uncertain: StringResource by lazy {
      StringResource("string:discover_groups_invite_uncertain", "discover_groups_invite_uncertain", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13378, 372),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 9905, 224),
      ))
    }

@delegate:ResourceContentHash(1_611_441_059)
internal val Res.string.discover_groups_join_failed: StringResource by lazy {
      StringResource("string:discover_groups_join_failed", "discover_groups_join_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13751, 107),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10130, 71),
      ))
    }

@delegate:ResourceContentHash(222_116_739)
internal val Res.string.discover_groups_join_public: StringResource by lazy {
      StringResource("string:discover_groups_join_public", "discover_groups_join_public", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13859, 79),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10202, 51),
      ))
    }

@delegate:ResourceContentHash(-734_632_412)
internal val Res.string.discover_groups_keep_writing: StringResource by lazy {
      StringResource("string:discover_groups_keep_writing", "discover_groups_keep_writing", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 13939, 80),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10254, 52),
      ))
    }

@delegate:ResourceContentHash(-338_203_072)
internal val Res.string.discover_groups_leave_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_leave_confirm_body", "discover_groups_leave_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14020, 338),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10307, 202),
      ))
    }

@delegate:ResourceContentHash(-262_289_132)
internal val Res.string.discover_groups_leave_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_leave_confirm_title", "discover_groups_leave_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14359, 91),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10510, 59),
      ))
    }

@delegate:ResourceContentHash(-1_948_818_006)
internal val Res.string.discover_groups_leave_failed: StringResource by lazy {
      StringResource("string:discover_groups_leave_failed", "discover_groups_leave_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14451, 112),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10570, 72),
      ))
    }

@delegate:ResourceContentHash(1_748_712_915)
internal val Res.string.discover_groups_leave_group: StringResource by lazy {
      StringResource("string:discover_groups_leave_group", "discover_groups_leave_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14564, 75),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10643, 51),
      ))
    }

@delegate:ResourceContentHash(-2_096_845_039)
internal val Res.string.discover_groups_like_comment_failed: StringResource by lazy {
      StringResource("string:discover_groups_like_comment_failed", "discover_groups_like_comment_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14640, 139),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10695, 83),
      ))
    }

@delegate:ResourceContentHash(-1_387_359_397)
internal val Res.string.discover_groups_like_limit: StringResource by lazy {
      StringResource("string:discover_groups_like_limit", "discover_groups_like_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14780, 218),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10779, 102),
      ))
    }

@delegate:ResourceContentHash(-550_648_511)
internal val Res.string.discover_groups_like_post_failed: StringResource by lazy {
      StringResource("string:discover_groups_like_post_failed", "discover_groups_like_post_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 14999, 124),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10882, 76),
      ))
    }

@delegate:ResourceContentHash(-1_853_835_471)
internal val Res.string.discover_groups_link_copied: StringResource by lazy {
      StringResource("string:discover_groups_link_copied", "discover_groups_link_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15124, 83),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 10959, 51),
      ))
    }

@delegate:ResourceContentHash(-1_855_633_693)
internal val Res.string.discover_groups_link_unopenable_body: StringResource by lazy {
      StringResource("string:discover_groups_link_unopenable_body", "discover_groups_link_unopenable_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15208, 148),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11011, 92),
      ))
    }

@delegate:ResourceContentHash(-1_108_409_836)
internal val Res.string.discover_groups_link_unopenable_title: StringResource by lazy {
      StringResource("string:discover_groups_link_unopenable_title", "discover_groups_link_unopenable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15357, 109),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11104, 81),
      ))
    }

@delegate:ResourceContentHash(-495_016_627)
internal val Res.string.discover_groups_linked_source: StringResource by lazy {
      StringResource("string:discover_groups_linked_source", "discover_groups_linked_source", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15467, 89),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11186, 57),
      ))
    }

@delegate:ResourceContentHash(1_560_572_455)
internal val Res.string.discover_groups_make_admin: StringResource by lazy {
      StringResource("string:discover_groups_make_admin", "discover_groups_make_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16078, 78),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11533, 50),
      ))
    }

@delegate:ResourceContentHash(1_308_923_944)
internal val Res.string.discover_groups_make_admin_body: StringResource by lazy {
      StringResource("string:discover_groups_make_admin_body", "discover_groups_make_admin_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15557, 391),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11244, 211),
      ))
    }

@delegate:ResourceContentHash(725_496_794)
internal val Res.string.discover_groups_make_admin_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_make_admin_confirm_title", "discover_groups_make_admin_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 15949, 128),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11456, 76),
      ))
    }

@delegate:ResourceContentHash(1_165_813_563)
internal val Res.string.discover_groups_mark_best_answer: StringResource by lazy {
      StringResource("string:discover_groups_mark_best_answer", "discover_groups_mark_best_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16157, 100),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11584, 68),
      ))
    }

@delegate:ResourceContentHash(2_057_591_873)
internal val Res.string.discover_groups_members: StringResource by lazy {
      StringResource("string:discover_groups_members", "discover_groups_members", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16258, 55),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11653, 43),
      ))
    }

@delegate:ResourceContentHash(1_229_078_483)
internal val Res.string.discover_groups_message_author: StringResource by lazy {
      StringResource("string:discover_groups_message_author", "discover_groups_message_author", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16546, 102),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11865, 54),
      ))
    }

@delegate:ResourceContentHash(-42_899_718)
internal val Res.string.discover_groups_message_author_action: StringResource by lazy {
      StringResource("string:discover_groups_message_author_action", "discover_groups_message_author_action", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16314, 85),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11697, 65),
      ))
    }

@delegate:ResourceContentHash(884_869_239)
internal val Res.string.discover_groups_message_author_failed: StringResource by lazy {
      StringResource("string:discover_groups_message_author_failed", "discover_groups_message_author_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16400, 145),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11763, 101),
      ))
    }

@delegate:ResourceContentHash(1_712_546_520)
internal val Res.string.discover_groups_new_group_title: StringResource by lazy {
      StringResource("string:discover_groups_new_group_title", "discover_groups_new_group_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16649, 71),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11920, 51),
      ))
    }

@delegate:ResourceContentHash(1_049_576_825)
internal val Res.string.discover_groups_new_post_title: StringResource by lazy {
      StringResource("string:discover_groups_new_post_title", "discover_groups_new_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16721, 70),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 11972, 50),
      ))
    }

@delegate:ResourceContentHash(304_042_992)
internal val Res.string.discover_groups_no_members_body: StringResource by lazy {
      StringResource("string:discover_groups_no_members_body", "discover_groups_no_members_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16792, 151),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12023, 91),
      ))
    }

@delegate:ResourceContentHash(-245_170_307)
internal val Res.string.discover_groups_no_members_found_body: StringResource by lazy {
      StringResource("string:discover_groups_no_members_found_body", "discover_groups_no_members_found_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 16944, 141),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12115, 85),
      ))
    }

@delegate:ResourceContentHash(669_936_016)
internal val Res.string.discover_groups_no_members_found_title: StringResource by lazy {
      StringResource("string:discover_groups_no_members_found_title", "discover_groups_no_members_found_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17086, 98),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12201, 70),
      ))
    }

@delegate:ResourceContentHash(1_055_894_765)
internal val Res.string.discover_groups_no_members_title: StringResource by lazy {
      StringResource("string:discover_groups_no_members_title", "discover_groups_no_members_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17185, 100),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12272, 68),
      ))
    }

@delegate:ResourceContentHash(-1_938_681_375)
internal val Res.string.discover_groups_no_permission: StringResource by lazy {
      StringResource("string:discover_groups_no_permission", "discover_groups_no_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17286, 129),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12341, 89),
      ))
    }

@delegate:ResourceContentHash(1_209_338_458)
internal val Res.string.discover_groups_not_the_author: StringResource by lazy {
      StringResource("string:discover_groups_not_the_author", "discover_groups_not_the_author", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17416, 118),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12431, 82),
      ))
    }

@delegate:ResourceContentHash(-1_276_258_783)
internal val Res.string.discover_groups_open_profile_of: StringResource by lazy {
      StringResource("string:discover_groups_open_profile_of", "discover_groups_open_profile_of", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17535, 119),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12514, 67),
      ))
    }

@delegate:ResourceContentHash(-1_497_078_613)
internal val Res.string.discover_groups_owner_cannot_leave: StringResource by lazy {
      StringResource("string:discover_groups_owner_cannot_leave", "discover_groups_owner_cannot_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17655, 226),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12582, 114),
      ))
    }

@delegate:ResourceContentHash(-1_979_182_503)
internal val Res.string.discover_groups_plan_action_failed: StringResource by lazy {
      StringResource("string:discover_groups_plan_action_failed", "discover_groups_plan_action_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17882, 106),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12697, 78),
      ))
    }

@delegate:ResourceContentHash(-1_350_842_014)
internal val Res.string.discover_groups_plan_cancel: StringResource by lazy {
      StringResource("string:discover_groups_plan_cancel", "discover_groups_plan_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 17989, 71),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12776, 51),
      ))
    }

@delegate:ResourceContentHash(1_471_314_788)
internal val Res.string.discover_groups_plan_capacity: StringResource by lazy {
      StringResource("string:discover_groups_plan_capacity", "discover_groups_plan_capacity", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18061, 117),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12828, 65),
      ))
    }

@delegate:ResourceContentHash(617_560_285)
internal val Res.string.discover_groups_plan_closed: StringResource by lazy {
      StringResource("string:discover_groups_plan_closed", "discover_groups_plan_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18179, 87),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12894, 71),
      ))
    }

@delegate:ResourceContentHash(803_089_491)
internal val Res.string.discover_groups_plan_complete: StringResource by lazy {
      StringResource("string:discover_groups_plan_complete", "discover_groups_plan_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18267, 61),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 12966, 49),
      ))
    }

@delegate:ResourceContentHash(-423_648_048)
internal val Res.string.discover_groups_plan_date: StringResource by lazy {
      StringResource("string:discover_groups_plan_date", "discover_groups_plan_date", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18329, 45),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13016, 41),
      ))
    }

@delegate:ResourceContentHash(-1_922_650_715)
internal val Res.string.discover_groups_plan_full: StringResource by lazy {
      StringResource("string:discover_groups_plan_full", "discover_groups_plan_full", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18375, 81),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13058, 49),
      ))
    }

@delegate:ResourceContentHash(-401_168_168)
internal val Res.string.discover_groups_plan_join: StringResource by lazy {
      StringResource("string:discover_groups_plan_join", "discover_groups_plan_join", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18457, 65),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13108, 45),
      ))
    }

@delegate:ResourceContentHash(198_711_372)
internal val Res.string.discover_groups_plan_leave: StringResource by lazy {
      StringResource("string:discover_groups_plan_leave", "discover_groups_plan_leave", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18523, 70),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13154, 50),
      ))
    }

@delegate:ResourceContentHash(387_192_769)
internal val Res.string.discover_groups_plan_participants: StringResource by lazy {
      StringResource("string:discover_groups_plan_participants", "discover_groups_plan_participants", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18693, 77),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13292, 65),
      ))
    }

@delegate:ResourceContentHash(-1_216_398_440)
internal val Res.string.discover_groups_plan_participants_capacity: StringResource by lazy {
      StringResource("string:discover_groups_plan_participants_capacity", "discover_groups_plan_participants_capacity", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18594, 98),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13205, 86),
      ))
    }

@delegate:ResourceContentHash(612_778_152)
internal val Res.string.discover_groups_plan_place: StringResource by lazy {
      StringResource("string:discover_groups_plan_place", "discover_groups_plan_place", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18771, 50),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13358, 42),
      ))
    }

@delegate:ResourceContentHash(514_556_410)
internal val Res.string.discover_groups_plan_time: StringResource by lazy {
      StringResource("string:discover_groups_plan_time", "discover_groups_plan_time", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18822, 49),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13401, 41),
      ))
    }

@delegate:ResourceContentHash(-470_535_230)
internal val Res.string.discover_groups_post_admins_only: StringResource by lazy {
      StringResource("string:discover_groups_post_admins_only", "discover_groups_post_admins_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 18872, 168),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13443, 108),
      ))
    }

@delegate:ResourceContentHash(-39_263_629)
internal val Res.string.discover_groups_post_deleted: StringResource by lazy {
      StringResource("string:discover_groups_post_deleted", "discover_groups_post_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19041, 84),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13552, 72),
      ))
    }

@delegate:ResourceContentHash(537_069_668)
internal val Res.string.discover_groups_post_field: StringResource by lazy {
      StringResource("string:discover_groups_post_field", "discover_groups_post_field", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19126, 66),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13625, 46),
      ))
    }

@delegate:ResourceContentHash(113_097_603)
internal val Res.string.discover_groups_post_limit: StringResource by lazy {
      StringResource("string:discover_groups_post_limit", "discover_groups_post_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19193, 230),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13672, 102),
      ))
    }

@delegate:ResourceContentHash(1_585_859_727)
internal val Res.string.discover_groups_post_load_failed: StringResource by lazy {
      StringResource("string:discover_groups_post_load_failed", "discover_groups_post_load_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19424, 120),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13775, 76),
      ))
    }

@delegate:ResourceContentHash(-1_074_363_741)
internal val Res.string.discover_groups_post_members_only: StringResource by lazy {
      StringResource("string:discover_groups_post_members_only", "discover_groups_post_members_only", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19545, 161),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13852, 97),
      ))
    }

@delegate:ResourceContentHash(-1_120_933_531)
internal val Res.string.discover_groups_post_more_actions: StringResource by lazy {
      StringResource("string:discover_groups_post_more_actions", "discover_groups_post_more_actions", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19707, 105),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 13950, 77),
      ))
    }

@delegate:ResourceContentHash(-1_786_642_243)
internal val Res.string.discover_groups_post_title: StringResource by lazy {
      StringResource("string:discover_groups_post_title", "discover_groups_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19813, 50),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14028, 42),
      ))
    }

@delegate:ResourceContentHash(289_887_403)
internal val Res.string.discover_groups_post_too_long: StringResource by lazy {
      StringResource("string:discover_groups_post_too_long", "discover_groups_post_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 19864, 149),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14071, 101),
      ))
    }

@delegate:ResourceContentHash(2_059_997_235)
internal val Res.string.discover_groups_post_unavailable_body: StringResource by lazy {
      StringResource("string:discover_groups_post_unavailable_body", "discover_groups_post_unavailable_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20014, 205),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14173, 141),
      ))
    }

@delegate:ResourceContentHash(1_046_715_942)
internal val Res.string.discover_groups_post_unavailable_title: StringResource by lazy {
      StringResource("string:discover_groups_post_unavailable_title", "discover_groups_post_unavailable_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20220, 110),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14315, 90),
      ))
    }

@delegate:ResourceContentHash(-330_694_096)
internal val Res.string.discover_groups_problem_description_too_long: StringResource by lazy {
      StringResource("string:discover_groups_problem_description_too_long", "discover_groups_problem_description_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20331, 168),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14406, 124),
      ))
    }

@delegate:ResourceContentHash(1_844_102_249)
internal val Res.string.discover_groups_problem_name_required: StringResource by lazy {
      StringResource("string:discover_groups_problem_name_required", "discover_groups_problem_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20500, 101),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14531, 77),
      ))
    }

@delegate:ResourceContentHash(1_246_018_156)
internal val Res.string.discover_groups_problem_name_too_long: StringResource by lazy {
      StringResource("string:discover_groups_problem_name_too_long", "discover_groups_problem_name_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20602, 161),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14609, 109),
      ))
    }

@delegate:ResourceContentHash(1_819_531_575)
internal val Res.string.discover_groups_problem_username_characters: StringResource by lazy {
      StringResource("string:discover_groups_problem_username_characters", "discover_groups_problem_username_characters", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20764, 187),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14719, 123),
      ))
    }

@delegate:ResourceContentHash(-483_711_174)
internal val Res.string.discover_groups_problem_username_required: StringResource by lazy {
      StringResource("string:discover_groups_problem_username_required", "discover_groups_problem_username_required", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 20952, 141),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14843, 93),
      ))
    }

@delegate:ResourceContentHash(457_515_047)
internal val Res.string.discover_groups_problem_username_reserved: StringResource by lazy {
      StringResource("string:discover_groups_problem_username_reserved", "discover_groups_problem_username_reserved", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21094, 141),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 14937, 109),
      ))
    }

@delegate:ResourceContentHash(-2_135_861_770)
internal val Res.string.discover_groups_problem_username_too_long: StringResource by lazy {
      StringResource("string:discover_groups_problem_username_too_long", "discover_groups_problem_username_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21236, 153),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15047, 109),
      ))
    }

@delegate:ResourceContentHash(1_083_659_019)
internal val Res.string.discover_groups_problem_username_too_short: StringResource by lazy {
      StringResource("string:discover_groups_problem_username_too_short", "discover_groups_problem_username_too_short", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21390, 154),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15157, 110),
      ))
    }

@delegate:ResourceContentHash(1_917_624_098)
internal val Res.string.discover_groups_problem_visibility: StringResource by lazy {
      StringResource("string:discover_groups_problem_visibility", "discover_groups_problem_visibility", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21545, 182),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15268, 110),
      ))
    }

@delegate:ResourceContentHash(394_048_406)
internal val Res.string.discover_groups_publish: StringResource by lazy {
      StringResource("string:discover_groups_publish", "discover_groups_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22287, 63),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15726, 39),
      ))
    }

@delegate:ResourceContentHash(1_946_045_468)
internal val Res.string.discover_groups_publish_failed: StringResource by lazy {
      StringResource("string:discover_groups_publish_failed", "discover_groups_publish_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21728, 178),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15379, 102),
      ))
    }

@delegate:ResourceContentHash(-1_933_431_713)
internal val Res.string.discover_groups_publish_offline: StringResource by lazy {
      StringResource("string:discover_groups_publish_offline", "discover_groups_publish_offline", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 21907, 135),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15482, 103),
      ))
    }

@delegate:ResourceContentHash(-1_737_097_029)
internal val Res.string.discover_groups_publish_timeout: StringResource by lazy {
      StringResource("string:discover_groups_publish_timeout", "discover_groups_publish_timeout", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22043, 243),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15586, 139),
      ))
    }

@delegate:ResourceContentHash(2_141_744_818)
internal val Res.string.discover_groups_qr_failed: StringResource by lazy {
      StringResource("string:discover_groups_qr_failed", "discover_groups_qr_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22351, 117),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15766, 77),
      ))
    }

@delegate:ResourceContentHash(743_965_913)
internal val Res.string.discover_groups_recipient_unavailable: StringResource by lazy {
      StringResource("string:discover_groups_recipient_unavailable", "discover_groups_recipient_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22469, 133),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15844, 101),
      ))
    }

@delegate:ResourceContentHash(-1_806_178_380)
internal val Res.string.discover_groups_refresh: StringResource by lazy {
      StringResource("string:discover_groups_refresh", "discover_groups_refresh", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22603, 55),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15946, 43),
      ))
    }

@delegate:ResourceContentHash(471_338_061)
internal val Res.string.discover_groups_remove: StringResource by lazy {
      StringResource("string:discover_groups_remove", "discover_groups_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23802, 54),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16749, 38),
      ))
    }

@delegate:ResourceContentHash(-727_889_585)
internal val Res.string.discover_groups_remove_admin: StringResource by lazy {
      StringResource("string:discover_groups_remove_admin", "discover_groups_remove_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23068, 64),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16279, 52),
      ))
    }

@delegate:ResourceContentHash(-1_629_714_708)
internal val Res.string.discover_groups_remove_admin_body: StringResource by lazy {
      StringResource("string:discover_groups_remove_admin_body", "discover_groups_remove_admin_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22659, 181),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 15990, 129),
      ))
    }

@delegate:ResourceContentHash(495_133_696)
internal val Res.string.discover_groups_remove_admin_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_remove_admin_confirm_title", "discover_groups_remove_admin_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22841, 134),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16120, 86),
      ))
    }

@delegate:ResourceContentHash(345_731_973)
internal val Res.string.discover_groups_remove_admin_rights: StringResource by lazy {
      StringResource("string:discover_groups_remove_admin_rights", "discover_groups_remove_admin_rights", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 22976, 91),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16207, 71),
      ))
    }

@delegate:ResourceContentHash(-755_446_944)
internal val Res.string.discover_groups_remove_confirm_body: StringResource by lazy {
      StringResource("string:discover_groups_remove_confirm_body", "discover_groups_remove_confirm_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23133, 375),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16332, 223),
      ))
    }

@delegate:ResourceContentHash(-1_143_715_194)
internal val Res.string.discover_groups_remove_confirm_title: StringResource by lazy {
      StringResource("string:discover_groups_remove_confirm_title", "discover_groups_remove_confirm_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23509, 104),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16556, 60),
      ))
    }

@delegate:ResourceContentHash(-1_929_653_080)
internal val Res.string.discover_groups_remove_from_group: StringResource by lazy {
      StringResource("string:discover_groups_remove_from_group", "discover_groups_remove_from_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23614, 89),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16617, 65),
      ))
    }

@delegate:ResourceContentHash(-611_005_140)
internal val Res.string.discover_groups_remove_saved_post: StringResource by lazy {
      StringResource("string:discover_groups_remove_saved_post", "discover_groups_remove_saved_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23704, 97),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16683, 65),
      ))
    }

@delegate:ResourceContentHash(-1_750_807_329)
internal val Res.string.discover_groups_reply: StringResource by lazy {
      StringResource("string:discover_groups_reply", "discover_groups_reply", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_discover-groups.commonMain.cvr", 23949, 53),
        ResourceItem(setOf(), "${MD}values/strings_discover-groups.commonMain.cvr", 16848, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("discover_groups_group_name_label", Res.string.discover_groups_group_name_label)
  map.put("discover_groups_group_name_placeholder", Res.string.discover_groups_group_name_placeholder)
  map.put("discover_groups_group_title", Res.string.discover_groups_group_title)
  map.put("discover_groups_group_unavailable_body", Res.string.discover_groups_group_unavailable_body)
  map.put("discover_groups_group_unavailable_title", Res.string.discover_groups_group_unavailable_title)
  map.put("discover_groups_group_username_label", Res.string.discover_groups_group_username_label)
  map.put("discover_groups_group_username_placeholder", Res.string.discover_groups_group_username_placeholder)
  map.put("discover_groups_invite_admins_only", Res.string.discover_groups_invite_admins_only)
  map.put("discover_groups_invite_create", Res.string.discover_groups_invite_create)
  map.put("discover_groups_invite_create_confirm", Res.string.discover_groups_invite_create_confirm)
  map.put("discover_groups_invite_create_title", Res.string.discover_groups_invite_create_title)
  map.put("discover_groups_invite_created_on", Res.string.discover_groups_invite_created_on)
  map.put("discover_groups_invite_history_note", Res.string.discover_groups_invite_history_note)
  map.put("discover_groups_invite_replace", Res.string.discover_groups_invite_replace)
  map.put("discover_groups_invite_replace_title", Res.string.discover_groups_invite_replace_title)
  map.put("discover_groups_invite_show", Res.string.discover_groups_invite_show)
  map.put("discover_groups_invite_title", Res.string.discover_groups_invite_title)
  map.put("discover_groups_invite_uncertain", Res.string.discover_groups_invite_uncertain)
  map.put("discover_groups_join_failed", Res.string.discover_groups_join_failed)
  map.put("discover_groups_join_public", Res.string.discover_groups_join_public)
  map.put("discover_groups_keep_writing", Res.string.discover_groups_keep_writing)
  map.put("discover_groups_leave_confirm_body", Res.string.discover_groups_leave_confirm_body)
  map.put("discover_groups_leave_confirm_title", Res.string.discover_groups_leave_confirm_title)
  map.put("discover_groups_leave_failed", Res.string.discover_groups_leave_failed)
  map.put("discover_groups_leave_group", Res.string.discover_groups_leave_group)
  map.put("discover_groups_like_comment_failed", Res.string.discover_groups_like_comment_failed)
  map.put("discover_groups_like_limit", Res.string.discover_groups_like_limit)
  map.put("discover_groups_like_post_failed", Res.string.discover_groups_like_post_failed)
  map.put("discover_groups_link_copied", Res.string.discover_groups_link_copied)
  map.put("discover_groups_link_unopenable_body", Res.string.discover_groups_link_unopenable_body)
  map.put("discover_groups_link_unopenable_title", Res.string.discover_groups_link_unopenable_title)
  map.put("discover_groups_linked_source", Res.string.discover_groups_linked_source)
  map.put("discover_groups_make_admin", Res.string.discover_groups_make_admin)
  map.put("discover_groups_make_admin_body", Res.string.discover_groups_make_admin_body)
  map.put("discover_groups_make_admin_confirm_title", Res.string.discover_groups_make_admin_confirm_title)
  map.put("discover_groups_mark_best_answer", Res.string.discover_groups_mark_best_answer)
  map.put("discover_groups_members", Res.string.discover_groups_members)
  map.put("discover_groups_message_author", Res.string.discover_groups_message_author)
  map.put("discover_groups_message_author_action", Res.string.discover_groups_message_author_action)
  map.put("discover_groups_message_author_failed", Res.string.discover_groups_message_author_failed)
  map.put("discover_groups_new_group_title", Res.string.discover_groups_new_group_title)
  map.put("discover_groups_new_post_title", Res.string.discover_groups_new_post_title)
  map.put("discover_groups_no_members_body", Res.string.discover_groups_no_members_body)
  map.put("discover_groups_no_members_found_body", Res.string.discover_groups_no_members_found_body)
  map.put("discover_groups_no_members_found_title", Res.string.discover_groups_no_members_found_title)
  map.put("discover_groups_no_members_title", Res.string.discover_groups_no_members_title)
  map.put("discover_groups_no_permission", Res.string.discover_groups_no_permission)
  map.put("discover_groups_not_the_author", Res.string.discover_groups_not_the_author)
  map.put("discover_groups_open_profile_of", Res.string.discover_groups_open_profile_of)
  map.put("discover_groups_owner_cannot_leave", Res.string.discover_groups_owner_cannot_leave)
  map.put("discover_groups_plan_action_failed", Res.string.discover_groups_plan_action_failed)
  map.put("discover_groups_plan_cancel", Res.string.discover_groups_plan_cancel)
  map.put("discover_groups_plan_capacity", Res.string.discover_groups_plan_capacity)
  map.put("discover_groups_plan_closed", Res.string.discover_groups_plan_closed)
  map.put("discover_groups_plan_complete", Res.string.discover_groups_plan_complete)
  map.put("discover_groups_plan_date", Res.string.discover_groups_plan_date)
  map.put("discover_groups_plan_full", Res.string.discover_groups_plan_full)
  map.put("discover_groups_plan_join", Res.string.discover_groups_plan_join)
  map.put("discover_groups_plan_leave", Res.string.discover_groups_plan_leave)
  map.put("discover_groups_plan_participants", Res.string.discover_groups_plan_participants)
  map.put("discover_groups_plan_participants_capacity", Res.string.discover_groups_plan_participants_capacity)
  map.put("discover_groups_plan_place", Res.string.discover_groups_plan_place)
  map.put("discover_groups_plan_time", Res.string.discover_groups_plan_time)
  map.put("discover_groups_post_admins_only", Res.string.discover_groups_post_admins_only)
  map.put("discover_groups_post_deleted", Res.string.discover_groups_post_deleted)
  map.put("discover_groups_post_field", Res.string.discover_groups_post_field)
  map.put("discover_groups_post_limit", Res.string.discover_groups_post_limit)
  map.put("discover_groups_post_load_failed", Res.string.discover_groups_post_load_failed)
  map.put("discover_groups_post_members_only", Res.string.discover_groups_post_members_only)
  map.put("discover_groups_post_more_actions", Res.string.discover_groups_post_more_actions)
  map.put("discover_groups_post_title", Res.string.discover_groups_post_title)
  map.put("discover_groups_post_too_long", Res.string.discover_groups_post_too_long)
  map.put("discover_groups_post_unavailable_body", Res.string.discover_groups_post_unavailable_body)
  map.put("discover_groups_post_unavailable_title", Res.string.discover_groups_post_unavailable_title)
  map.put("discover_groups_problem_description_too_long", Res.string.discover_groups_problem_description_too_long)
  map.put("discover_groups_problem_name_required", Res.string.discover_groups_problem_name_required)
  map.put("discover_groups_problem_name_too_long", Res.string.discover_groups_problem_name_too_long)
  map.put("discover_groups_problem_username_characters", Res.string.discover_groups_problem_username_characters)
  map.put("discover_groups_problem_username_required", Res.string.discover_groups_problem_username_required)
  map.put("discover_groups_problem_username_reserved", Res.string.discover_groups_problem_username_reserved)
  map.put("discover_groups_problem_username_too_long", Res.string.discover_groups_problem_username_too_long)
  map.put("discover_groups_problem_username_too_short", Res.string.discover_groups_problem_username_too_short)
  map.put("discover_groups_problem_visibility", Res.string.discover_groups_problem_visibility)
  map.put("discover_groups_publish", Res.string.discover_groups_publish)
  map.put("discover_groups_publish_failed", Res.string.discover_groups_publish_failed)
  map.put("discover_groups_publish_offline", Res.string.discover_groups_publish_offline)
  map.put("discover_groups_publish_timeout", Res.string.discover_groups_publish_timeout)
  map.put("discover_groups_qr_failed", Res.string.discover_groups_qr_failed)
  map.put("discover_groups_recipient_unavailable", Res.string.discover_groups_recipient_unavailable)
  map.put("discover_groups_refresh", Res.string.discover_groups_refresh)
  map.put("discover_groups_remove", Res.string.discover_groups_remove)
  map.put("discover_groups_remove_admin", Res.string.discover_groups_remove_admin)
  map.put("discover_groups_remove_admin_body", Res.string.discover_groups_remove_admin_body)
  map.put("discover_groups_remove_admin_confirm_title", Res.string.discover_groups_remove_admin_confirm_title)
  map.put("discover_groups_remove_admin_rights", Res.string.discover_groups_remove_admin_rights)
  map.put("discover_groups_remove_confirm_body", Res.string.discover_groups_remove_confirm_body)
  map.put("discover_groups_remove_confirm_title", Res.string.discover_groups_remove_confirm_title)
  map.put("discover_groups_remove_from_group", Res.string.discover_groups_remove_from_group)
  map.put("discover_groups_remove_saved_post", Res.string.discover_groups_remove_saved_post)
  map.put("discover_groups_reply", Res.string.discover_groups_reply)
}
